import React  from "react";
import { useParams } from 'react-router-dom';
import AwardForm from "./components/RewardForm";
import Card from "components/card";

const EditAward = () => {

	const { awardID } = useParams();
	console.log("test", awardID);
	return (
	    <div>
			<Card extra={"w-full h-full p-4"}>
				<div className="mt-5 grid h-full grid-cols-1 gap-4">
					<AwardForm recordId={awardID} mode="edit"/>
				</div>
			</Card>
	    </div>
    );
};

export default EditAward;